import React, { useState, useEffect } from "react";
import { fetchBusinessPresentation } from '../bridge.js';
import { IoPersonOutline, IoStarOutline } from 'react-icons/io5';
import '../styles/BusinessDescription.css';

const BusinessDescription = ({ userEmail }) => {
    const [aboutText, setAboutText] = useState('');
    const [servicesText, setServicesText] = useState('');

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
      const previousBusinessPresentation = await fetchBusinessPresentation(userEmail);
      if (previousBusinessPresentation) {
        setAboutText(previousBusinessPresentation.about_section || '');
        setServicesText(previousBusinessPresentation.services_section || '');
      }
    };

    return (
        <div className="sections-container">
          {aboutText && (
            <div className="description-card">
              <div className="description-card-header about-header">
                <div className="description-header-icon">
                  <IoPersonOutline size={20} color="#DDA85C" />
                </div>
                <span className="description-header-title">About Us</span>
              </div>
              <div className="description-card-body">
                <p className="description-text">{aboutText}</p>
              </div>
            </div>
          )}
          {servicesText && (
            <div className="description-card">
              <div className="description-card-header services-header">
                <div className="description-header-icon">
                  <IoStarOutline size={20} color="#fff" />
                </div>
                <span className="description-header-title">Our Services</span>
              </div>
              <div className="description-card-body">
                <p className="description-text">{servicesText}</p>
              </div>
            </div>
          )}
        </div>
    )
};

export default BusinessDescription;
